import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquiselect-menu',
	templateUrl:'./JQUISelectMenuPage.html',
	styles: [],
	styleUrls:['./JQUISelectMenuPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUISelectMenuPage
{
	mdContent_213 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.selectmenu.JQUISelectMenu;
\`\`\``;
	mdContent_214 = `\`\`\`java
new JQUISelectMenu&lt;&gt;()
\`\`\``;
	mdContent_215 = `\`\`\`java
var select = new JQUISelectMenu<>();
select.addOption("Option 1", "1");
select.addOption("Option 2", "2");
\`\`\``;
}
